const CHEVRON_PATH =
  'M60.7,53.6,50,64.3m0,0L39.3,53.6M50,64.3V35.7m0,46.4A32.1,32.1,0,1,1,82.1,50,32.1,32.1,0,0,1,50,82.1Z';

function createChevronIcon(): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('class', 'fancy-select-icon');
  svg.setAttribute('viewBox', '0 0 100 100');
  svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('fill', 'none');
  path.setAttribute('stroke-width', '4');
  path.setAttribute('stroke-linejoin', 'round');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('d', CHEVRON_PATH);
  svg.appendChild(path);
  return svg;
}

/** Enveloppe un select natif dans le composant stylé (glow + chevron, thème clair/sombre). */
export function wrapFancySelect(select: HTMLSelectElement): HTMLDivElement {
  select.classList.add('fancy-select-input');
  select.classList.remove('dice-ui-select');

  const wrap = document.createElement('div');
  wrap.className = 'fancy-select';

  const glow = document.createElement('span');
  glow.className = 'fancy-select-glow';
  glow.setAttribute('aria-hidden', 'true');

  wrap.append(glow, createChevronIcon(), select);
  return wrap;
}

export function appendFancySelect(parent: HTMLElement, select: HTMLSelectElement): void {
  parent.appendChild(wrapFancySelect(select));
}
